import React from "react";
import { useTranslation } from "react-i18next";
import { redirectUserToHomePageAfterRegistration } from "@utils";
import { OnBoardingSlider, OnBoardingFooter } from "../shared";
import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { HeaderType } from "@data-types/layout/headerTypeEnum";

export default function OnboardingRegistrationSuccess() {
	const { t } = useTranslation("registration");
	const redirectToHomePage = () => {
		redirectUserToHomePageAfterRegistration();
	};

	return (
		<DesktopLayout
			headerType={HeaderType.EMPTY}
			mainClassName="at-registrationSuccess l--membership"
		>
			<section className="l--content l--content--full">
				<div className="l--content__main u-padd--reset">
					<div className="l--membership__container">
						<div className="card--membership card--primary">
							<OnBoardingSlider hasOnboardingStyling={true} />

							<div className="card--membership__main">
								<div className="card--membership__message">
									<div className="card--membership__header u-display--f--col u-mar--bottom--med">
										<i className="u-icon u-icon--xlrg u-icon--check-circle u-icon--animated--bounce-in u-color--sent--success" />
										<div className="card--membership__title u-mar--top--xsml">
											{t(
												"REGISTRATION_SUCCESS.CONGRATULATIONS"
											)}
										</div>
									</div>

									<div className="u-mar--bottom--med">
										<div className="u-mar--bottom--xsml">
											{t(
												"REGISTRATION_SUCCESS.SUCCESSFULY_CREATED"
											)}
										</div>
										<div>
											{t(
												"REGISTRATION_SUCCESS.REGISTRATION_NOTE"
											)}
										</div>
									</div>

									<div className="u-mar--bottom--med">
										<div className="u-mar--bottom--xsml u-type--med u-type--wgt--medium u-color--text--primary">
											{t(
												"REGISTRATION_SUCCESS.PLAY_RESPONSIBLY"
											)}
										</div>
										<div>
											{t(
												"REGISTRATION_SUCCESS.RESPONSIBLE_GAMING_MESSAGE"
											)}
										</div>
									</div>

									<div>
										{t(
											"REGISTRATION_SUCCESS.WISHES_MESSAGE"
										)}
									</div>
								</div>

								<button
									type="button"
									className="at-regSuccessBtn btn btn--base btn--block btn--accent"
									onClick={redirectToHomePage}
								>
									{t("COMMON.BACK_TO_HOME_PAGE")}
								</button>
							</div>
						</div>

						<OnBoardingFooter hasOnboardingStyling={true} />
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
}
